module.exports = __webpack_public_path__ + "static/media/blog-05.0f25a94d.jpg";